module.exports = __webpack_public_path__ + "img/close.1c792175.svg";